/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ strong: NonNullable<unknown> }} Misc_Posts_Speciallist_Replayability1Inputs */

const id_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Banyak koleksi, misi sampingan, dan rahasia tersembunyi.`)
};

const ms_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Banyak koleksi, misi sampingan, dan rahsia tersembunyi.`)
};

const da_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Masser af samleobjekter, side-missioner og skjulte hemmeligheder.`)
};

const de_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Jede Menge Sammelobjekte, Nebenmissionen und versteckte Geheimnisse.`)
};

const en_us2_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Tons of collectibles, side missions, and hidden secrets.`)
};

const es_es2_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Montones de coleccionables, misiones secundarias y secretos ocultos.`)
};

const es_mx2_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Montones de coleccionables, misiones secundarias y secretos ocultos.`)
};

const fil_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Maraming collectibles, side missions, at nakatagong mga lihim.`)
};

const fr_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong} : Des tonnes d'objets à collectionner, de missions secondaires et de secrets cachés.`)
};

const it_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Tonnellate di collezionabili, missioni secondarie e segreti nascosti.`)
};

const hu_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Rengeteg gyűjthető tárgy, mellékküldetés és rejtett titok.`)
};

const nl_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Talloze verzamelobjecten, zijmissies en verborgen geheimen.`)
};

const no_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.strong}: Massevis av samleobjekter, sideoppdrag og skjulte hemmeligheter.`)
};

const pl_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Mnóstwo kolekcjonerskich przedmiotów, misji pobocznych i ukrytych sekretów.`)
};

const pt_br2_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Toneladas de itens colecionáveis, missões secundárias e segredos escondidos.`)
};

const pt_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Muitos colecionáveis, missões secundárias e segredos escondidos.`)
};

const ro_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: O mulțime de colectibile, misiuni secundare și secrete ascunse.`)
};

const fi_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Valtavasti keräilyesineitä, sivutehtäviä ja piilotettuja salaisuuksia.`)
};

const sv_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Massor av samlarobjekt, sidouppdrag och dolda hemligheter.`)
};

const vi_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Vô số đồ sưu tầm, nhiệm vụ phụ và bí mật ẩn giấu.`)
};

const tr_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Bir sürü koleksiyon öğesi, yan görev ve gizli sır.`)
};

const cs_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Spousta sběratelských předmětů, vedlejších misí a skrytých tajemství.`)
};

const bg_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Тонове колекционерски предмети, странични мисии и скрити тайни.`)
};

const ru_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Тонны коллекционных предметов, побочных миссий и скрытых секретов.`)
};

const uk_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: Безліч колекційних предметів, побічних місій та прихованих секретів.`)
};

const ar_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: الكثير من المواد القابلة للتحصيل والمهام الجانبية والأسرار المخفية.`)
};

const hi_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: पुनः खेलने की क्षमता।`)
};

const th_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: ของสะสมมากมาย ภารกิจเสริม และความลับที่ซ่อนอยู่`)
};

const ja_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}：たくさんの収集品、サイドミッション、隠された秘密。`)
};

const zh_cn2_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}：海量的收集要素、支线任务和隐藏秘密。`)
};

const zh_hant1_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: 大量收藏品、支線任務和隱藏秘密。`)
};

const ko_misc_posts_speciallist_replayability1 = /** @type {(inputs: Misc_Posts_Speciallist_Replayability1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`🤯 ${i?.strong}: 수많은 수집품, 사이드 미션 및 숨겨진 비밀.`)
};

/**
* | output |
* | --- |
* | "🤯 {strong}: Tons of collectibles, side missions, and hidden secrets." |
*
* @param {Misc_Posts_Speciallist_Replayability1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_speciallist_replayability1 = /** @type {((inputs: Misc_Posts_Speciallist_Replayability1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Speciallist_Replayability1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_speciallist_replayability1(inputs)
	if (locale === "ms") return ms_misc_posts_speciallist_replayability1(inputs)
	if (locale === "da") return da_misc_posts_speciallist_replayability1(inputs)
	if (locale === "de") return de_misc_posts_speciallist_replayability1(inputs)
	if (locale === "en-US") return en_us2_misc_posts_speciallist_replayability1(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_speciallist_replayability1(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_speciallist_replayability1(inputs)
	if (locale === "fil") return fil_misc_posts_speciallist_replayability1(inputs)
	if (locale === "fr") return fr_misc_posts_speciallist_replayability1(inputs)
	if (locale === "it") return it_misc_posts_speciallist_replayability1(inputs)
	if (locale === "hu") return hu_misc_posts_speciallist_replayability1(inputs)
	if (locale === "nl") return nl_misc_posts_speciallist_replayability1(inputs)
	if (locale === "no") return no_misc_posts_speciallist_replayability1(inputs)
	if (locale === "pl") return pl_misc_posts_speciallist_replayability1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_speciallist_replayability1(inputs)
	if (locale === "pt") return pt_misc_posts_speciallist_replayability1(inputs)
	if (locale === "ro") return ro_misc_posts_speciallist_replayability1(inputs)
	if (locale === "fi") return fi_misc_posts_speciallist_replayability1(inputs)
	if (locale === "sv") return sv_misc_posts_speciallist_replayability1(inputs)
	if (locale === "vi") return vi_misc_posts_speciallist_replayability1(inputs)
	if (locale === "tr") return tr_misc_posts_speciallist_replayability1(inputs)
	if (locale === "cs") return cs_misc_posts_speciallist_replayability1(inputs)
	if (locale === "bg") return bg_misc_posts_speciallist_replayability1(inputs)
	if (locale === "ru") return ru_misc_posts_speciallist_replayability1(inputs)
	if (locale === "uk") return uk_misc_posts_speciallist_replayability1(inputs)
	if (locale === "ar") return ar_misc_posts_speciallist_replayability1(inputs)
	if (locale === "hi") return hi_misc_posts_speciallist_replayability1(inputs)
	if (locale === "th") return th_misc_posts_speciallist_replayability1(inputs)
	if (locale === "ja") return ja_misc_posts_speciallist_replayability1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_speciallist_replayability1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_speciallist_replayability1(inputs)
	return ko_misc_posts_speciallist_replayability1(inputs)
});
export { misc_posts_speciallist_replayability1 as "misc.posts.specialList.replayability" }